import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_BankTransactionImport = _resolveComponent("BankTransactionImport")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialog) = $event)),
    title: "Importez votre relevé bancaire",
    "previous-display": _ctx.wizardStep !== 0,
    actions: _ctx.actions,
    prefixDataCy: "ImportBankMain-valid",
    "min-width": "70vw"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.wizardStep,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.wizardStep) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_ctx.currentUser.profile.configuration.bankTransaction.import)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        ripple: "",
                        class: "oss-list-item-xl mb-2 py-3",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.wizardStep = 1)),
                        "data-cy": "importBankMain-csv"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "x-small",
                            color: "light_grey"
                          }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("$fa-chevron-right")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode(" Importer un fichier Excel ou CSV (recommandé) ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, { class: "text-wrap" }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode(" Importez les relevés bancaires provenant d'un fichier fourni par le site internet de votre banque au format Excel, .csv ou .tsv ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.profile.configuration.bankTransaction.import)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        ripple: "",
                        class: "oss-list-item-xl mb-2 py-3",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.wizardStep = 4)),
                        "data-cy": "importBankMain-ofx"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "x-small",
                            color: "light_grey"
                          }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode("$fa-chevron-right")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode(" Importer un fichier OFX (Open Financial Exchange) ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, { class: "text-wrap" }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode(" Importez les relevés bancaires provenant d'un fichier fourni par le site internet de votre banque au format OFX ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.profile.configuration.bankTransaction.import)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 2,
                        ripple: "",
                        class: "oss-list-item-xl mb-2 py-3",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {
                            _ctx.wizardStep = 3;
                            _ctx.actions.action.previous = () => _ctx.back();
                        }),
                        "data-cy": "importBankMain-pdf"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "x-small",
                            color: "light_grey"
                          }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode("$fa-chevron-right ")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode(" Importer un fichier PDF (non recommandé) ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, { class: "text-wrap" }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode(" Communiquez à votre cabinet comptable vos relevés bancaires au format pdf. Cette méthode est à éviter si vous pouvez communiquer les mouvements bancaires au format csv. ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, {
            value: 1,
            class: "pt-3",
            "data-cy": "ImportBankMain-import"
          }, {
            default: _withCtx(() => [
              (
                        _ctx.currentUser.profile.configuration.bankTransaction.import && _ctx.wizardStep === 1
                    )
                ? (_openBlock(), _createBlock(_component_BankTransactionImport, {
                    key: 0,
                    scanBank: false,
                    title: 'Sélectionnez l\'export bancaire à importer (.csv, .xlsx, .tsv .txt)',
                    actions: _ctx.actions,
                    documentType: 'BANK_STATEMENT',
                    selectedAccountId: _ctx.selectedAccountId,
                    onDocumentImported: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imported())),
                    onBack: _cache[4] || (_cache[4] = ($event: any) => (_ctx.back()))
                  }, null, 8, ["actions", "selectedAccountId"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 2 }, {
            default: _withCtx(() => [
              (
                        _ctx.currentUser.profile.configuration.bankTransaction.import && _ctx.wizardStep === 2
                    )
                ? (_openBlock(), _createBlock(_component_BankTransactionImport, {
                    key: 0,
                    scanBank: true,
                    title: 'Sélectionnez l\'export ScanBank à importer',
                    actions: _ctx.actions,
                    documentType: 'BANK_STATEMENT',
                    selectedAccountId: _ctx.selectedAccountId,
                    onDocumentImported: _cache[5] || (_cache[5] = ($event: any) => (_ctx.imported())),
                    onBack: _cache[6] || (_cache[6] = ($event: any) => (_ctx.back()))
                  }, null, 8, ["actions", "selectedAccountId"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 3 }, {
            default: _withCtx(() => [
              (
                        _ctx.currentUser.profile.configuration.bankTransaction.import && _ctx.wizardStep === 3
                    )
                ? (_openBlock(), _createBlock(_component_UploadDocuments, {
                    key: 0,
                    companyId: _ctx.companyId,
                    documentType: 'BANK_STATEMENT',
                    multiple: true,
                    freeTag: false,
                    inExtensions: ['pdf'],
                    actions: _ctx.actions,
                    onFilesUploaded: _ctx.imported
                  }, null, 8, ["companyId", "actions", "onFilesUploaded"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 4 }, {
            default: _withCtx(() => [
              (
                        _ctx.currentUser.profile.configuration.bankTransaction.import && _ctx.wizardStep === 4
                    )
                ? (_openBlock(), _createBlock(_component_BankTransactionImport, {
                    key: 0,
                    scanBank: false,
                    ofx: true,
                    title: 'Sélectionnez l\'export OFX à importer',
                    actions: _ctx.actions,
                    documentType: 'BANK_STATEMENT',
                    selectedAccountId: _ctx.selectedAccountId,
                    onDocumentImported: _cache[7] || (_cache[7] = ($event: any) => (_ctx.imported())),
                    onBack: _cache[8] || (_cache[8] = ($event: any) => (_ctx.back()))
                  }, null, 8, ["actions", "selectedAccountId"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "previous-display", "actions"]))
}